import { render, staticRenderFns } from "./Foyda.vue?vue&type=template&id=84a16706&scoped=true"
import script from "./Foyda.vue?vue&type=script&lang=js"
export * from "./Foyda.vue?vue&type=script&lang=js"
import style0 from "./Foyda.vue?vue&type=style&index=0&id=84a16706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a16706",
  null
  
)

export default component.exports